import { Pipe, PipeTransform } from '@angular/core'
import { titlecase } from '@mmx/shared'

@Pipe({ name: 'titlecase', standalone: false })
export class TitleCasePipe implements PipeTransform {
  transform(text: string): string {
    return titlecase(text)
  }
}
